import { Actions, ActionTypes } from './actions';
import { initialState, UserState } from './state';

export function userReducer(state = initialState, action: Actions): UserState {
  switch (action.type) {
    case ActionTypes.SET_SELECTED_REQUEST: {
      return {
        ...state,
        selected: action.user ? { ...action.user } : null,
        isLoading: false,
        error: null,
      };
    }

    default: {
      return state;
    }
  }
}
